import { Worker } from "./Worker";

export const INITIAL_VALUES: Worker = {
	workerId: 0,
	workerTypeId: 0,
	workerName: "",
	isActive: true,
};
